import "./style.scss";
import { useForm } from "react-hook-form";
import { useState } from "react";
import BoxAlert from "../../LoginComponent/BoxAlert";
import BoxError from "../../LoginComponent/BoxError";
import axios from "axios";
import Loading from "../../LoadingComponent";
import { useTranslation } from "react-i18next";

const ForgetPassword = () => {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();
    const { t } = useTranslation();
    const [complete, setComplete] = useState(false);
    const [dataObj, setDataObj] = useState({});
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);

    document.querySelector("body").style.overflow = "auto";

    async function onSubmit(data, event) {
        event.preventDefault();
        const email = data.email;
        setError(false);
        setLoading(true);
        axios
            .post("/api/user/forgetPassword", {
                email: email,
                url: `${window.location.protocol}//${window.location.host}`,
            })
            .then(({ data }) => {
                setLoading(false);
                if (data.status == 200) {
                    setComplete(true);
                } else {
                    setDataObj({ no_email: email });
                    setError(true);
                }
            });
    }

    return (
        <section className="forget-password section-login-register-template">
            {loading && <Loading />}
            <img
                src="/img/mbog-official-logo.png"
                alt=""
                style={{
                    margin: "0 auto 40px",
                    width: "200px",
                    height: "auto",
                    display: "block",
                }}
            />
            {complete ? (
                <BoxAlert title={t("alert_email_rest_success")} paragraph={t("alert_email_to_reset")} />
            ) : (
                <div className="box-login-register-template box-register">
                    <div className="wrapper-form">
                        <h2>{t("forget_password")}</h2>
                        {error && (
                            <BoxError>
                                <li>
                                    {t("profile_email")} {dataObj.no_email} {t("email_unexist")}
                                </li>
                            </BoxError>
                        )}
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className={`group-input ${errors.email && "error"}`}>
                                <label htmlFor="">{t("fill_email_register")}</label>
                                <input type="text" {...register("email", { required: true })} />
                                {errors.email?.type === "required" && (
                                    <span className="error">{t("error_required_email")}</span>
                                )}
                            </div>
                            <input type="submit" value={t("btn_sent_email_reset_pass")} />
                        </form>
                    </div>
                </div>
            )}
        </section>
    );
};

export default ForgetPassword;
